// An option for use in a select list
export interface SelectOption {
    key: string;
    value: boolean;
}
const Yes: SelectOption = { key: 'Yes', value: true };
const No: SelectOption = { key: 'No', value: false };

/**
 * A utility class to provide predefined collections of common select options for use in HTML forms
 */
export class SelectOptions {
    /** Yes/No options in the order Yes, No */
    static readonly YesNo: SelectOption[] = [Yes, No];
    
    /** Yes/No options in the order No, Yes */
    static readonly NoYes: SelectOption[] = [No, Yes];

    /**
     * Helper function to provide ordered Yes/No select options. This is generally used to
     * present the currently-selected value first.
     * @param value - A boolean value to convert to Yes/No options
     * @returns An array of two Yes/No select options based on the value provided
     */
    static booleanOptionsFor(value: boolean | null | undefined): SelectOption[] {
        return value ? SelectOptions.YesNo : SelectOptions.NoYes;
    }
}
